import styled from "styled-components";
import { baseLight, errorColor } from "../../../constants";

export const ErrorMessageContainer = styled.div<any>`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${baseLight};
  background: ${errorColor};
  padding: 10px;

  border-radius: ${({ radiusStyle }) => (radiusStyle ? "8px" : "0")};

  @media screen and (max-width: 768px) {
    border-radius: 0px;
  }
`;

export const FieldErrorIconContainer = styled.div`
  display: inline-flex;
  flex-shrink: 0;
`;

export const ErrorText = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  margin: 0 10px;

  @media screen and (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;
